import { AlertTriangle, Loader2, RefreshCw } from 'lucide-react';

/**
 * Small shared primitives for page-level loading and error states.
 *
 * Design intent: subtle and inline — these sit above/within existing content
 * so pages remain useful (often rendering seed fallback) while the API
 * status is visible.
 */

export function InlineSpinner({ label = 'Loading…' }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-text-secondary">
      <Loader2 size={12} className="animate-spin" />
      {label}
    </span>
  );
}

export function LoadingBar() {
  return (
    <div
      className="h-0.5 w-full overflow-hidden rounded-full bg-accent/10"
      aria-hidden="true"
    >
      <div className="h-full w-1/3 bg-accent animate-[pulse_1.2s_ease-in-out_infinite]" />
    </div>
  );
}

export function ErrorBanner({ message, onRetry, detail }) {
  const fallback = detail
    ? `Showing cached/demo data — ${detail}`
    : 'Showing cached/demo data while we reconnect.';
  return (
    <div
      role="alert"
      className="flex items-start gap-3 rounded-btn border border-[#FCA5A5] bg-[#FEF2F2]
                 px-4 py-3 text-sm text-[#991B1B]"
    >
      <AlertTriangle size={16} className="mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="font-medium">
          {message || 'We couldn’t load the latest data from the server.'}
        </p>
        <p className="text-xs text-[#7F1D1D]/80 mt-0.5">{fallback}</p>
      </div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="inline-flex items-center gap-1.5 rounded-btn border border-[#FCA5A5]
                     bg-white px-3 py-1 text-xs font-medium text-[#991B1B]
                     hover:bg-[#FEF2F2] transition-colors"
        >
          <RefreshCw size={12} />
          Retry
        </button>
      )}
    </div>
  );
}

export default { InlineSpinner, LoadingBar, ErrorBanner };
